/**
 * A card whose data is not collected yet (ADR 0012). It states what the card will show and that it is
 * not collected, and it has no figure slot at all — so there is no way to render a zero in it, which
 * would read as a finding about a platform that has simply not been asked yet.
 */
export function NotCollected({ title, says }: { title: string; says: string }) {
  return (
    <div className="border border-dashed border-line bg-surface p-4">
      <div className="text-[11px] font-semibold uppercase tracking-[0.12em] text-ink-800">{title}</div>
      <p className="mt-1.5 text-xs text-ink-800">{says}</p>
    </div>
  );
}
